import React from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import { GearGridCell } from './GearGridCell';
import { SvgIcon } from '@progress/kendo-react-common';
import { lockIcon, unlockIcon } from '@progress/kendo-svg-icons';

interface LockCellProps extends GridCellProps {
  linked?: boolean;
  onLinkClicked?: () => void;
}

export const LockCell: React.FC<LockCellProps> = props => {
  const { linked, onLinkClicked, ...restProps } = props;
  const isLocked = Boolean(props.dataItem[props.field || '']);

  const title = isLocked ? 'Locked' : 'Unlocked';

  const handleClick = (e: React.MouseEvent) => {
    if (linked && onLinkClicked) {
      e.preventDefault();
      e.stopPropagation();
      onLinkClicked();
    }
  };

  return (
    <GearGridCell {...restProps} title={title} className={linked ? 'k-grid-link-cell linked' : ''}>
      {linked ? (
        <a href="#" className="grid-link" onClick={handleClick}>
          <span className="lockedCell">
            <span className="linked-lock-cell">
              <SvgIcon
                icon={isLocked ? lockIcon : unlockIcon}
                size="large"
                themeColor={isLocked ? 'error' : 'success'}
              />
            </span>
          </span>
        </a>
      ) : (
        <span className="lockedCell">
          <SvgIcon icon={isLocked ? lockIcon : unlockIcon} size="large" themeColor={isLocked ? 'error' : 'success'} />
        </span>
      )}
    </GearGridCell>
  );
};
